import type { CommonData } from '@/components/blockEditor/blockEditor.types';
import { CURRENT_SCHEMA_VERSION } from '@/components/blockEditor/blockEditor.types';

export function getDefaultGratOverviewPageTwoData(): CommonData {
  return {
    version: CURRENT_SCHEMA_VERSION,
    blocks: [
      {
        id: 'grat-overview-page-two-list',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'grat-overview-page-two-heading',
              type: 'EducationalSlideHeading',
              props: {
                title: 'Is a GRAT right for me?',
                variant: 'h3',
              },
            },
            {
              id: 'grat-overview-page-two-estate',
              type: 'PresentationListItem',
              props: {
                title: 'Estate size',
                description:
                  'If your estate exceeds or is close to the federal estate tax exemption, a GRAT can provide significant tax benefits.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'grat-overview-page-two-discountable',
              type: 'PresentationListItem',
              props: {
                iconColor: 'PRIMARY',
                title: 'Discountable assets',
                description:
                  'GRATs can be structured to take advantage of valuation discounts particularly for illiquid or privately-held assets, increasing the probability of successfully transferring wealth out of the grantor’s estate.',
                iconType: 'check',
              },
            },
            {
              id: 'grat-overview-page-two-gifts',
              type: 'PresentationListItem',
              props: {
                title: 'Making irrevocable gifts',
                description:
                  'For many grantors there is often a fear of making gifts. GRATs can be a very effective way to transfer appreciation of your estate to heirs while retaining principal.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'grat-overview-page-two-taxes',
              type: 'PresentationListItem',
              props: {
                title: 'Ongoing tax payments',
                description:
                  'Because the grantor must pay income taxes generated by the GRAT, it is necessary to ensure that the grantor has sufficient liquid assets to pay taxes during the trust term.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'grat-overview-page-two-guidance',
              type: 'PresentationListItem',
              props: {
                title: 'Professional guidance',
                description:
                  'Consulting with estate planning professionals, including attorneys and financial advisors, is essential to evaluate whether a GRAT aligns with your overall financial strategy.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
          ],
        },
      },
    ],
  };
}
